module.exports = __webpack_public_path__ + "img/ar.24cad56c.svg";